import list from './list'
export default {
    list: list,
    name: "dashboard",
    key: "p_dashboard",
}
